import { render, staticRenderFns } from "./syssetting-product.vue?vue&type=template&id=51f8a545&scoped=true"
import script from "./syssetting-product.vue?vue&type=script&lang=js"
export * from "./syssetting-product.vue?vue&type=script&lang=js"
import style0 from "./syssetting-product.vue?vue&type=style&index=0&id=51f8a545&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f8a545",
  null
  
)

export default component.exports